// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"42":"0fc1102a6b149038","96":"d20e103b018931a9","458":"af126cb41d31192d"}[chunkId] + ".js";
};